<app-shipment-assignment-action
  *ngIf="driverRunningShipment || truckRunningShipment"
  [driverRunningShipment]="driverRunningShipment"
  [truckRunningShipment]="truckRunningShipment"
  [shipmentId]="shipmentId"
  [form]="form"
  [isViewActions]="isViewActions"
  (assignShipmentActionChange)="assignShipmentActionChange.emit($event)"
></app-shipment-assignment-action>
